import React, { useEffect } from "react";
// import DatePicker from "../../ui/forms/DatePicker";
import ReactTooltip from "react-tooltip";
import NoRecord from "../../Components/NoRecord";
import ContentLoader from "../../Components/ContentLoader";
import { useState } from "react";
import { format } from "date-fns";
import { getAgentPerformanceSummary } from "../../API/agentApis"; // Assuming this is now getAgentPerformanceSummary
import useAuthStore from "../../store/authStore";
import IncomingCall from "../Components/IncomingCall";
import { showToast } from "../../utils/handleToast";
import { commaFormat } from "../../Functions/formatNumber";

// Helper function to format time (e.g., "1h 30m") - kept simple for the new API format
const formatTime = (time) => (time || "0m");

// Component for the vertical divider between table cells
function Divider() {
  return (
    <span
      style={{
        position: "absolute",
        top: "50%",
        right: "0%",
        height: "50%",
        width: "1px",
        backgroundColor: "#ccc",
        display: "block",
        transform: "translateY(-50%)",
      }}
    />
  );
}

// Main component: MyEarnings
export default function MyEarnings() {
  const userData = useAuthStore((state) => state.userData);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // NEW STATE for monthly summary
  const [monthlySummary, setMonthlySummary] = useState(null);

  const [date, setDate] = useState(null);
  const [sort, setSort] = useState("");

  const clearFilter = () => {
    setData(null);
    setSort("");
    setMonthlySummary(null);
  };

  async function fetchData() {
    setLoading(true);


    const res = await getAgentPerformanceSummary({ agent_id: userData?.user_id });

    if (res?.status && res?.data) {
      // CRITICAL CHANGE: Extracting daily_performance array and monthly_summary object
      setData(res.data?.daily_performance || []);
      setMonthlySummary(res.data?.monthly_summary || null);

    } else {
      showToast({ message: "Unable to fetch details.", variant: "danger" });
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Tooltip content for Not Eligible Talktime
  const notEligibleTooltipContent = "Blank calls + No disposition. Add disposition & avoid longer blanks to earn more.";

  // Icon for the tooltip (e.g., an 'i' for info)
  const infoIcon = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
    </svg>
  );

  // Component to render the Monthly Summary Card
  const MonthlySummaryCard = ({ summary }) => {
      if (!summary) return null;

      // Extract and format data for display
      const talkTimeDisplay = summary.total_talk_time.replace(' mins', 'm');
      const notEligibleTalkTimeDisplay = summary.total_not_eligible_talktime.replace(' mins', 'm');
      const earningsDisplay = `₹ ${commaFormat(summary.total_earnings)}`;


      // **FINAL FIX:** Using a table structure with table-layout: fixed to enforce alignment
      return (
          <div className="card shadow-sm p-3 mb-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
              {/* Use a table to mimic the column layout */}
              <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                  <tbody>
                      <tr>
                        
                          <td style={{ minWidth: '120px', padding: '0', textAlign: 'left', border: 'none' }}>
                              <strong style={{ fontSize: "1.25rem" }}>{summary.month_year}</strong>
                          </td>

                          
                          <td className="text-center" style={{ minWidth: '130px', padding: '0 1rem', border: 'none' }}>
                              <span style={{ color: "#6c757d", fontSize: "0.875rem" }}>Total Eligible Talk-Time</span>
                              <br />
                              <strong style={{ fontSize: "1.1rem" }}>{talkTimeDisplay}</strong>
                          </td>

                         
                          <td className="text-center" style={{ minWidth: '160px', padding: '0 1rem', border: 'none' }}>
                              <span
                                  style={{ color: "#6c757d", fontSize: "0.875rem", cursor: 'pointer' }}
                                  data-tip data-for="monthly_not_eligible_tooltip"
                              >
                                  Total Not Eligible Talktime
                                  {infoIcon}
                              </span>
                              <br />
                              <strong style={{ fontSize: "1.1rem" }}>{notEligibleTalkTimeDisplay}</strong>
                              <ReactTooltip effect="solid" place="bottom" className="py-2 px-3" id="monthly_not_eligible_tooltip">
                                  <div style={{ fontWeight: "normal", maxWidth: "250px", textAlign: 'left' }}>
                                      <strong>Not Eligible:</strong> {notEligibleTooltipContent}
                                  </div>
                              </ReactTooltip>
                          </td>

                         
                          <td className="text-center" style={{ minWidth: '100px', padding: '0 0 0 1rem', border: 'none' }}>
                              <span style={{ color: "#6c757d", fontSize: "0.875rem" }}>Total Earnings</span>
                              <br />
                              <strong style={{ fontSize: "1.1rem" }}>{earningsDisplay}</strong>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      );
  };

  return (
    // REVISED: Remove 'imp-lead-layout' and use a full-width style container
    <div className="pageContent h-100 w-100" style={{ padding: '1rem', boxSizing: 'border-box' }}>

      {/* Monthly Summary Card */}
      {monthlySummary && <MonthlySummaryCard summary={monthlySummary} />}

      {!!data?.length && !loading && (
        // REVISED: Ensure content takes full available height and width
        <div className="imp-leads-content mt-0 h-100" style={{ width: '100%' }}>
          <div className="table-scroll h-100" style={{ overflowY: 'auto' }}>
            {/* REVISED: Adding a table header for better context */}
            <table className="agent-filter-table" style={{ width: '100%', tableLayout: 'fixed' }}>
                <thead>
                    <tr style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1, borderBottom: '2px solid #ddd' }}>
                        {/* Headers maintain their minWidth and alignment for consistency */}
                        <th style={{ minWidth: '120px', padding: '1rem 0', textAlign: 'left' }}>Date</th>
                        <th style={{ minWidth: '130px', padding: '1rem 0', textAlign: 'center' }}>Eligible Talk Time</th>
                        <th style={{ minWidth: '160px', padding: '1rem 0', textAlign: 'center' }}>Not Eligible Talktime</th>
                        <th style={{ minWidth: '100px', padding: '1rem 0', textAlign: 'center' }}>Earnings</th>
                    </tr>
                </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={index}>
                    {/* 1. Date Column */}
                    <td className="py-4" style={{ position: "relative", minWidth: '120px', paddingRight: '1rem' }}>
                      <div>
                        <strong style={{ fontSize: "1rem" }}>
                          {!!item?.date ? format(new Date(item?.date), "dd MMM yyyy") : "No Date"}
                        </strong>
                      </div>
                      <Divider />
                    </td>

                    {/* 2. Eligible Talk Time Column */}
                    <td className="py-4 px-4" style={{ position: "relative", minWidth: '130px' }}>
                      <div className="text-center">
                        <span style={{ fontWeight: "500", color: "#000", fontSize: "1rem" }}>{formatTime(item?.talk_time)}</span>
                        <br />
                        <span style={{ fontSize: "0.75rem" }}>Eligible Talk Time</span>
                      </div>
                      <Divider />
                    </td>

                    {/* 3. Not Eligible Talktime Column - REMOVED INFO ICON */}
                    <td className="py-4 px-4" style={{ position: "relative", minWidth: '160px' }}>
                      <div className="text-center">
                        <span style={{ fontWeight: "500", color: "#000", fontSize: "1rem" }}>
                          {formatTime(item?.not_eligible_talktime)}
                        </span>
                        <br />
                        {/* The span was modified to remove data-tip, data-for, and {infoIcon} */}
                        <span
                          style={{ fontSize: "0.75rem" }}
                        >
                          Not Eligible Talktime
                        </span>
                        {/* The ReactTooltip component for the daily table was removed as well, since the icon is gone. */}
                      </div>
                      <Divider /> {/* Added divider for the new last column if present */}
                    </td>

                    {/* 4. Earnings Column (MOVED TO LAST POSITION) */}
                    <td className="py-4" style={{ position: "relative", minWidth: '100px' }}>
                      <div className="text-center">
                        <strong style={{ fontSize: "1rem" }}>Rs. {commaFormat(parseInt(item?.earnings)) || 0}</strong>
                        <br />
                        <span style={{ fontSize: "0.75rem" }}>Earnings</span>
                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loading && !data?.length && <NoRecord />}
      {loading && <ContentLoader />}
      <IncomingCall />
    </div>
  );
}